export default __webpack_public_path__ + "static/media/edo-effectieve-school@2x.3daca527.png";